import { ReassignPurchaseOrdersStep } from "src/routes/developments/reassign-purchase-orders/enums";
import { defineRoute } from "src/routing/defineRoute";
import { developmentRoute } from "src/routing/domains/developments/detail/developmentDetailPaths";
import { developmentEditOptionsRoute } from "src/routing/domains/developments/plan-and-options/planAndOptionsPaths";
import { developmentReviewTemplatesRoute } from "src/routing/domains/developments/templates/templatesPaths";

/**
 * Path + typed URL builder pairs for development full-page flows (no SideNav).
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 *
 * `edit-options` / `review` path constants live in their feature subtrees; re-exported here for the
 * full-page route module. Cost mapping uses a different top-level prefix.
 */
export { developmentEditOptionsRoute, developmentReviewTemplatesRoute };

export const developmentReassignPurchaseOrdersRoute = defineRoute(`${developmentRoute.path}/reassign-purchase-orders`);
export const reassignPurchaseOrdersPath = `${developmentReassignPurchaseOrdersRoute.path}/:currentStep`;
export const reassignPurchaseOrdersPaths: Record<ReassignPurchaseOrdersStep, string> = {
  [ReassignPurchaseOrdersStep.SELECT]: `${developmentReassignPurchaseOrdersRoute.path}/${ReassignPurchaseOrdersStep.SELECT}`,
  [ReassignPurchaseOrdersStep.RELEASE]: `${developmentReassignPurchaseOrdersRoute.path}/${ReassignPurchaseOrdersStep.RELEASE}`,
};

export const costMappingPath = "/schedule-cost-mapping/:developmentId";
export const costMappingRoute = defineRoute(costMappingPath);
